export default __webpack_public_path__ + "static/media/cardio-badge.ee95fde0.svg";